import React, { useEffect, useRef } from "react";
import {
  View,
  Text,
  StyleSheet,
  Animated,
  TouchableOpacity,
  useWindowDimensions,
} from "react-native";
import { Feather } from "@expo/vector-icons";
import { COLORS } from "../../screens/tenants/tenantOnboarding/screens/components/PropertyDetailsCard";


interface Props {
  title: string;
  subText?: string;
  buttonText?: string;
  onButtonPress?: () => void;
}

const EmptyState: React.FC<Props> = ({
  title,
  subText,
  buttonText,
  onButtonPress,
}) => {
  const { width } = useWindowDimensions();
  const isMobile = width < 768;

  const fadeAnim = useRef(new Animated.Value(0)).current;
  const scaleAnim = useRef(new Animated.Value(0.95)).current;

  useEffect(() => {
    Animated.parallel([
      Animated.timing(fadeAnim, {
        toValue: 1,
        duration: 400,
        useNativeDriver: true,
      }),
      Animated.spring(scaleAnim, {
        toValue: 1,
        friction: 6,
        useNativeDriver: true,
      }),
    ]).start();
  }, []);

  return (
    <View style={styles.wrapper}>
      <Animated.View
        style={[
          styles.card,
          isMobile && { padding: 30 },
          {
            opacity: fadeAnim,
            transform: [{ scale: scaleAnim }],
          },
        ]}
      >
        {/* Icon Circle */}
        <View style={styles.iconCircle}>
          <Feather
            name="folder"
            size={42}
            color={COLORS.primary}
          />
        </View>

        {/* Title */}
        <Text style={styles.title}>{title}</Text>

        {/* Subtitle */}
        {subText && <Text style={styles.subText}>{subText}</Text>}

        {/* Button */}
        {buttonText && onButtonPress && (
          <TouchableOpacity
            style={styles.button}
            activeOpacity={0.8}
            onPress={onButtonPress}
          >
            <Feather name="plus" size={16} color="#fff" />
            <Text style={styles.buttonText}>{buttonText}</Text>
          </TouchableOpacity>
        )}
      </Animated.View>
    </View>
  );
};

export default EmptyState;

const styles = StyleSheet.create({
  wrapper: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    paddingVertical: 60,
  },

  card: {
    width: "100%",
    maxWidth: 650,
    padding: 50,
    borderRadius: 24,
    backgroundColor: COLORS.primary + "08",
    borderWidth: 2,
    borderStyle: "dashed",
    borderColor: COLORS.primary + "40",
    alignItems: "center",
  },

  iconCircle: {
    width: 100,
    height: 100,
    borderRadius: 50,
    backgroundColor: COLORS.primary + "15",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 25,
  },

  title: {
    fontSize: 24,
    fontWeight: "700",
    color: "#111",
    marginBottom: 12,
    textAlign: "center",
  },

  subText: {
    fontSize: 15,
    color: "#666",
    textAlign: "center",
    maxWidth: 450,
    lineHeight: 22,
    marginBottom: 25,
  },

  button: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: COLORS.primary,
    paddingHorizontal: 22,
    paddingVertical: 12,
    borderRadius: 30,
    elevation: 3,
  },

  buttonText: {
    color: "#fff",
    fontWeight: "600",
    marginLeft: 8,
  },
});